import React from "react";

const getStatusText = (status, t) => {
  const translations = t || { pending: "Pending", approved: "Approved", rejected: "Rejected" };
  return ({ pending: translations.pending, approved: translations.approved, rejected: translations.rejected }[status] || status);
};

const TabsBar = ({ activeTab, onTabChange, theme, isRTL, t, getStatusText: getStatusTextProp }) => {
  const resolveStatusText = (status) => {
    if (typeof getStatusTextProp === "function") return getStatusTextProp(status);
    return getStatusText(status, t);
  };

  const tabsContainer = {
    display: "flex",
    gap: "12px",
    marginBottom: "0",
    padding: "0",
    background: "transparent",
    borderRadius: "0",
    border: "none",
    flexWrap: "wrap",
    backdropFilter: "none",
    WebkitBackdropFilter: "none",
    transition: "all 0.3s ease",
    overflowX: "auto",
    scrollBehavior: "smooth",
    justifyContent: isRTL ? "flex-end" : "flex-start",
    boxShadow: "none",
  };

  const getTabColor = (status) => {
    const colors = {
      pending: { bg: "linear-gradient(135deg, #f59e0b, #f97316)", icon: "⏳", label: "Pending" },
      approved: { bg: "linear-gradient(135deg, #10b981, #059669)", icon: "✓", label: "Approved" },
      rejected: { bg: "linear-gradient(135deg, #ef4444, #dc2626)", icon: "✕", label: "Rejected" },
    };
    return colors[status] || colors.pending;
  };

  const tabButton = {
    padding: "12px 28px",
    borderRadius: "10px",
    border: "none",
    background: theme === "dark"
      ? "rgba(255,255,255,0.08)"
      : "rgba(0,0,0,0.06)",
    cursor: "pointer",
    fontWeight: "600",
    fontSize: "15px",
    transition: "all 0.2s ease",
    color: theme === "dark" ? "rgba(255,255,255,0.75)" : "rgba(26,26,26,0.75)",
    letterSpacing: "0.3px",
    textTransform: "capitalize",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    position: "relative",
    overflow: "hidden",
    whiteSpace: "nowrap",
    minWidth: "auto",
    boxShadow: "none",
    backdropFilter: "none",
    WebkitBackdropFilter: "none",
  };

  const activeTabButton = (status) => {
    const { bg } = getTabColor(status);
    return {
      background: bg,
      color: "#fff",
      fontWeight: "700",
      letterSpacing: "0.4px",
      boxShadow: "none",
      transform: "scale(1)",
      backdropFilter: "none",
      WebkitBackdropFilter: "none",
      opacity: 1,
    };
  };

  const handleTabChange = (tab) => {
    if (typeof onTabChange === "function") {
      onTabChange(tab);
    }
  };

  return (
    <div style={tabsContainer}>
      {["pending", "approved", "rejected"].map((tab) => (
        <button
          key={tab}
          onClick={() => handleTabChange(tab)}
          style={{ 
            ...tabButton, 
            ...(activeTab === tab ? activeTabButton(tab) : {}) 
          }}
          className="tab-button"
          onMouseEnter={(e) => {
            if (activeTab !== tab) {
              e.currentTarget.style.background = theme === "dark"
                ? "rgba(255,255,255,0.15)"
                : "rgba(0,0,0,0.12)";
              e.currentTarget.style.color = theme === "dark"
                ? "rgba(255,255,255,0.9)"
                : "rgba(26,26,26,0.9)";
              e.currentTarget.style.transform = "scale(1)";
              e.currentTarget.style.boxShadow = "none";
            }
          }}
          onMouseLeave={(e) => {
            if (activeTab !== tab) {
              e.currentTarget.style.background = theme === "dark"
                ? "rgba(255,255,255,0.08)"
                : "rgba(0,0,0,0.06)";
              e.currentTarget.style.color = theme === "dark"
                ? "rgba(255,255,255,0.75)"
                : "rgba(26,26,26,0.75)";
              e.currentTarget.style.transform = "scale(1)";
              e.currentTarget.style.boxShadow = "none";
            }
          }}
        >
          {resolveStatusText(tab)}
        </button>
      ))}
    </div>
  );
};

export default TabsBar;